module.exports = __webpack_public_path__ + "static/media/p8-2.42e3bac4.png";